import {useEffect, useState} from "react";
import {FiMapPin} from "react-icons/fi";
import {LuTimer} from "react-icons/lu";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {AnalyzerPhase} from "@/pages/analyzer/Analyzer.types.ts";
import {getBulkLocationsBound, getProposalIntervalRange} from "@/pages/analyzer/Analyzer.utils.ts";
import {AnalyzerSetIntervalsModal} from "@/pages/analyzer/components/AnalyzerSetIntervalsModal.tsx";
import {AnalyzerSetLocationsModal} from "@/pages/analyzer/components/AnalyzerSetLocationsModal.tsx";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

export const AnalyzerQuickActions = () => {
  const {user} = useCurrentUserContext();
  const {phase, selectedProposals, formData} = useAnalyzerContext();
  const [showIntervals, setShowIntervals] = useState(false);
  const [showLocations, setShowLocations] = useState(false);
  const disabled = phase !== AnalyzerPhase.CHECK_SELECTION || !selectedProposals.length;

  useEffect(() => {
    if (disabled) {
      setShowIntervals(false);
      setShowLocations(false);
    }
  }, [disabled]);

  if (!user?.has_write_access) {
    return null;
  }
  const noAdjustableIntervals =
    !!formData && !selectedProposals.some((check) => getProposalIntervalRange(formData, check));
  const noAdjustableLocations = !!formData && getBulkLocationsBound(formData, selectedProposals) <= 1;

  return (
    <>
      <Tooltip
        tooltipContent={noAdjustableIntervals ? "All selected Checks have a fixed Interval" : undefined}
        placement="top"
      >
        <span className="d-flex">
          <TableCrownButton disabled={disabled || noAdjustableIntervals} onClick={() => setShowIntervals(true)}>
            <Icon icon={LuTimer} />
            Set Intervals
          </TableCrownButton>
        </span>
      </Tooltip>
      <Tooltip
        tooltipContent={noAdjustableLocations ? "Selected Checks can't use more than 1 Location" : undefined}
        placement="top"
      >
        <span className="d-flex">
          <TableCrownButton disabled={disabled || noAdjustableLocations} onClick={() => setShowLocations(true)}>
            <Icon icon={FiMapPin} />
            Set Locations
          </TableCrownButton>
        </span>
      </Tooltip>
      <AnalyzerSetIntervalsModal show={showIntervals} setShow={setShowIntervals} />
      <AnalyzerSetLocationsModal show={showLocations} setShow={setShowLocations} />
    </>
  );
};
